"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withMouseEventsHandlers = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var ClickAction_1 = require("@wix/dealer-common/dist/src/services/ClickAction");
exports.withMouseEventsHandlers = function (Component) {
    var result = /** @class */ (function (_super) {
        tslib_1.__extends(WithMouseEventsHandlers, _super);
        function WithMouseEventsHandlers(props) {
            var _this = _super.call(this, props) || this;
            _this.onMouseEnterHandler = function () {
                _this.setState({ hover: true });
            };
            _this.onMouseLeaveHandler = function () {
                _this.setState({ hover: false });
            };
            _this.onClickHandler = function () {
                _this.clickAction.click(_this.props.element, _this.props.dealerOptions);
            };
            _this.onKeyDownHandler = function (event) {
                if (event.key === ' ' || event.key === 'Enter') {
                    _this.clickAction.click(_this.props.element, _this.props.dealerOptions);
                    event.preventDefault();
                }
            };
            _this.state = { hover: false };
            var _a = _this.props, bannerContext = _a.bannerContext, locale = _a.locale, metasiteId = _a.metasiteId, bannerRoot = _a.bannerRoot, bannerPosition = _a.bannerPosition, onClick = _a.onClick, onClose = _a.onClose, biLogger = _a.biLogger;
            _this.clickAction = new ClickAction_1.ClickAction(bannerContext, locale, metasiteId, bannerRoot, bannerPosition, onClick, onClose, biLogger);
            return _this;
        }
        WithMouseEventsHandlers.prototype.render = function () {
            return (React.createElement("span", { onMouseEnter: this.onMouseEnterHandler, onMouseLeave: this.onMouseLeaveHandler, onClick: this.onClickHandler, onKeyDown: this.onKeyDownHandler },
                React.createElement(Component, tslib_1.__assign({ hover: this.state.hover }, this.props))));
        };
        return WithMouseEventsHandlers;
    }(React.Component));
    return result;
};
//# sourceMappingURL=WithMouseEventsHandlers.js.map